/**
 * FotoKtpGrid Component
 *
 * Grid layout for displaying member foto KTP cards.
 */

import * as React from "react";
import { FotoKtpCard } from "./FotoKtpCard";
import { Skeleton } from "@/components/ui/skeleton";

export interface FotoKtpMember {
  _id: string;
  nama_lengkap: string;
  callsign: string;
  nri: string | null;
  iar: string;
  foto: string | null;
  idcardEncrypted: boolean;
  idcardUrl: string | null;
  idcardUploadedAt: string | null;
  no_hp: string | null;
  email: string | null;
  isFotoValid: boolean | null;
  fotoRejectionReason: string | null;
}

interface FotoKtpGridProps {
  members: FotoKtpMember[];
  loading: boolean;
  tabMode: "semua" | "hold";
  onZoom: (src: string, title: string) => void;
  onAction: (member: FotoKtpMember, mode: "reject" | "approve") => void;
}

function CardSkeleton() {
  return (
    <div className="overflow-hidden rounded-lg border">
      <div className="grid grid-cols-2">
        <Skeleton className="aspect-[3/4]" />
        <Skeleton className="aspect-[3/4]" />
      </div>
      <div className="p-3 space-y-2">
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-3 w-1/2" />
        <Skeleton className="h-3 w-full" />
        <Skeleton className="h-8 w-full" />
      </div>
    </div>
  );
}

export function FotoKtpGrid({ members, loading, tabMode, onZoom, onAction }: FotoKtpGridProps) {
  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {Array.from({ length: 8 }).map((_, i) => (
          <CardSkeleton key={i} />
        ))}
      </div>
    );
  }

  if (members.length === 0) {
    return (
      <div className="text-center py-12 text-muted-foreground">
        <p>{tabMode === "hold" ? "Tidak ada foto yang ditolak" : "Tidak ada data foto KTP yang ditemukan"}</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      {members.map((member) => (
        <FotoKtpCard
          key={member._id}
          member={member}
          onZoom={onZoom}
          onAction={onAction}
          tabMode={tabMode}
        />
      ))}
    </div>
  );
}
